/** @format */

export const PLP_CONSTANTS: any = {
	appPathPrefix: 'f',
	adeptmindScriptPath: 'https://www.dickssportinggoods.com/a/js/pdpScript.js',
	leadingZeroDoubleDigits: ['01', '02', '03', '04', '05', '06', '07', '08', '09'],
	singleDigits: {
		low: ['1', '2', '3', '4'],
		all: ['1', '2', '3', '4', '5', '6', '7', '8', '9']
	},
	refreshAddToCartTimeout: 20000,
	pdpJsonFileName: {
		bannedWords: 'banned-words-091019.json',
		brandsData: 'brands-data-09152021.json',
		categoriesData: 'categories-data-11102021.json',
		ecodesData: 'ecodes-data-04102020.json',
		shippingMessages: 'shipping-messages-01292025.json',
		exclusiveContent: 'exclusive-content.json'
	},
	infoSummaryAttribute: {
		ids: ['2571', '2617', '2527', '1511', '2568', '2567', '2564', '5576', '1739'],
		values: ['Mountain', 'Sleeping Bags', 'Tents']
	},
	footwearApparelAttrNames: ['color', 'shoesize', 'shoewidth', 'size', 'inseam'],
	footwearAttrNames: ['shoesize', 'shoewidth'],
	exclusiveBrands: ['Nike', 'Gold'],
	partyAttributes: {
		nike: 'nike_connected',
		gold: 'gold'
	},
	exclusiveCTATypes: {
		nike: {
			loggedIn: 'connectAccounts',
			notLoggedIn: 'signIn'
		},
		gold: {
			loggedIn: 'locked',
			notLoggedIn: 'lockedSignIn'
		}
	},
	exclusiveApeValue: {
		nike: 'Nike APE Exclusive',
		gold: 'Gold APE Exclusive'
	},
	partyAttrText: 'partyAttributes'
};
